export function element(name, { className = "", text = "" } = {}) {
  const node = document.createElement(name);
  if (className) {
    node.className = className;
  }
  if (text) {
    node.textContent = text;
  }
  return node;
}

export function translate(key, fallback) {
  const language = globalThis.window?.__fishystuffLanguage;
  if (typeof language?.t === "function") {
    const translated = language.t(key);
    if (translated && translated !== key) {
      return translated;
    }
  }
  return fallback;
}
